import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { REBelegart } from '@work4all/models/lib/Enums/REBelegart.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

export type InvoiceKindPickerProps<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

const reducedREBelegart = [
  REBelegart.EINGANGSRECHNUNG,
  REBelegart.KASSENBELEG,
  REBelegart.PROFORMA_KOSTENBELEG,
];

export function InvoiceKindPicker<TMultiple extends boolean>(
  props: InvoiceKindPickerProps<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return reducedREBelegart
      .map((id) => {
        return {
          id,
          name: t(`INVOICE_KINDS.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
